import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, ProgressBar, Button, Tab, Tabs, Dropdown } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";

import Docmnt from '../../../../assets/images/google-docs.png';
import Cargoplane from "../../../../assets/images/plane.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Loading from "../../../../assets/images/loading.png";
import Unloading from "../../../../assets/images/Unloading.png";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKAWBDETAILS } from '../../../../Utils/conts.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';


const AwbView = () => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [filterApplied, setFilterApplied] = useState(false);
    const [gridData, setGridData] = useState([]);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);

    const stationData = JSON.parse(localStorage.getItem('Handler_stn'));
    const tabName = localStorage.getItem('spl_lu');
    useEffect(() => {

        if (gridRef.current) {
            // if (gridData) {
            // const localData = gridData[activeTab].map(item => ({

            //     id: item.id,
            //     STN: item.station_code,
            //     Taddrs: item.station_addresses.length,
            //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
            // }));
            // var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || localStorage.airlinetoken || '');
            jqxCookieCall();
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}monitor/awb-view-list?station=${stationData.station_name}&tab_name=${tabName}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'awb_number', type: 'string' },
                    { name: 'pick_status', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'rcf', type: 'string' },
                    { name: 'man', type: 'string' },
                    { name: 'msca', type: 'string' },
                    { name: 'package', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'lm', type: 'string' },
                    { name: 'nature_of_goods', type: 'string' },
                    { name: 'order_no', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'truck_date', type: 'date' },
                    { name: 'order_type', type: 'string' },

                ],
                filter: function (allfilters) {
                    window.$(gridRef.current).jqxGrid('clearselection');
                    setGridSelect([]);

                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                    }
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
                // localdata: gridData,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Airway Bill', datafield: 'awb_number', width: '8%' },
                {
                    text: 'Order Type', filtertype: 'checkedlist', datafield: 'order_type', width: '8%',
                    filteritems: [
                        { label: 'Loading', value: 'Loading' },
                        { label: 'Unloading', value: 'Unloading' },
                    ],

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue === 'Loading') {
                            return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                        } else if (cellValue === 'Unloading') {
                            return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    text: 'Pickup Status', datafield: 'pick_status', width: '11%', filterable: false,
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            // Generate multiple divs for each item in the array
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join(''); // Combine all divs into a single string

                            return `<div class="stats_view">${content}</div>`;
                        }
                        // Fallback if value is not an array or empty
                        return defaulthtml;
                    }
                },
                { text: 'Pcs', datafield: 'pieces', width: '5%' },
                { text: 'RCF', datafield: 'rcf', width: '5%' },
                { text: 'MAN', datafield: 'man', width: '5%' },
                { text: 'MSCA', datafield: 'msca', width: '5%' },
                { text: 'Order No', datafield: 'order_no', width: '7%' },
                { text: 'Truck No', datafield: 'truck_no', width: '7%' },
                { text: 'Truck Date', datafield: 'truck_date', cellsformat: 'dd-MM-yyyy', filtertype: 'range', width: '7%' },
                { text: 'Package', datafield: 'package', width: '7%' },
                { text: 'ULD No.', datafield: 'uld_number', width: '7%' },
                { text: 'Weight', datafield: 'weight', width: '5%' },
                { text: 'Volume', datafield: 'volume', width: '5%' },
                { text: 'LM', datafield: 'lm', width: '5%' },
                { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '5%' },
            ];



            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                height: 1040,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: '', // checkbox
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },

            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                // console.log('event', args)
                if (event.args.columnindex > -1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    loadDetails(args.awb_id);
                    // setSelectedRowData(args);
                }
            });

            // }
        }
    }, [gridData]);

    const loadDetails = async (id) => {
        setDisLoading(true);
        try {
            const res = await withRFSToken.post(TRUCKAWBDETAILS, { awb_id: id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);
                    setDisLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
        window.$(gridRef.current).jqxGrid("updatebounddata");
    };

    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }

    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };

    const movementHistoryClick = () => {
        localStorage.removeItem('MHistory');
        const storageData = {
            ULD: selectedRowData,  // ULD Details section
            Form: {}  // Empty form section
        };
        localStorage.setItem('MHistory', JSON.stringify(storageData));
        // localStorage.setItem('tab', 'operations');
        window.location.href = '/ULDControl/MovementHistory'
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END
    return (
        <>
            {console.log('selectedRowData', selectedRowData)}
            <div className="main-content">
                {disLoading &&
                    <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                }
                <div className='maindiv'>
                    <div className='trashdonload'>
                        {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                    </div>
                    {selectedRowData && (
                        <div className='SecondDiv'>
                            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                            <div className='girddtals_header'>
                                <h3>
                                    {selectedRowData.awb_no} &nbsp;
                                    <span className='position-relative'>
                                        {
                                            selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                                                selectedRowData?.pick_status.map((item) =>
                                                    <>
                                                        {/* <div class=""> */}
                                                        <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                        {/* </div> */}
                                                    </>
                                                )
                                                : ''
                                        }
                                    </span>
                                </h3>
                                <div className='d-flex actbtn'>

                                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                    {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                                </div>

                            </div>
                            <div className='d-flex justify-content-between my-3'>
                                <div className='order_view'>
                                    <h3>{selectedRowData.loading_station}</h3>
                                    {/* <span>{selectedRowData.loading_name}</span> */}
                                    <span>
                                        {selectedRowData.loading_name && selectedRowData.loading_name.length > 20
                                            ? `${selectedRowData.loading_name.slice(0, 20)}...`
                                            : selectedRowData.loading_name}
                                    </span>
                                    <div className='mt-3'>
                                        <p>Scheduled - <b>{selectedRowData.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                        <p>Actual - <b>{selectedRowData.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                                    </div>
                                </div>
                                <div className='order_middle'>
                                    <p><img src={Cargotruck} /></p>
                                    <span>{selectedRowData.truck_number}</span>
                                </div>
                                <div className='order_view'>
                                    <h3>{selectedRowData.unloading_station}</h3>
                                    {/* <span>{selectedRowData.unloading_name}</span> */}
                                    <span>
                                        {selectedRowData.unloading_name && selectedRowData.unloading_name.length > 20
                                            ? `${selectedRowData.unloading_name.slice(0, 20)}...`
                                            : selectedRowData.unloading_name}
                                    </span>
                                    <div className='mt-3'>
                                        <p>Scheduled - <b>{selectedRowData.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                        <p>ETA - <b>{selectedRowData.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <ProgressBar animated now={50} style={{ height: "5px" }} />
                            </div>
                            <div className='movment_history'>
                                <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                            </div>
                            <div className='movment_list'>
                                <ul>
                                    {selectedRowData && selectedRowData?.status_updates.map((history, index) => (
                                        <li>
                                            <span className='movem w-auto'>{history.status}</span>
                                            <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                            {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <ImageUpload
                                ref={imageUploadRef}
                                attachable_type={"rfs_awb"}
                                attachable_id={selectedRowData.awb_id}
                                attachments={selectedRowData.attachments}
                                onDeleteSuccess={() => loadDetails(selectedRowData.awb_id)}
                            />
                            <ActivityComments
                                commentable_type={"rfs_awb"}
                                commentable_id={selectedRowData.awb_id}
                                allactivities={selectedRowData.activities}
                                onReloadDetails={() => loadDetails(selectedRowData.awb_id)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
};

export default AwbView;